<template>
    <div class="agency-dashboard container-fluid" aria-label="Agency dashboard">
        <section
            class="agency-selector mb-3"
            aria-labelledby="agency-selector-heading"
        >
            <h2 id="agency-selector-heading" class="visually-hidden">
                Select agency
            </h2>
            <form class="d-flex align-items-center">
                <label
                    id="agency-label"
                    for="agency"
                    class="align-self-center me-3"
                >
                    Select Agency
                </label>
                <div class="col-3">
                    <b-agency
                        name="agency"
                        v-model="agency"
                        :can-clear="false"
                        :select-first="true"
                        aria-labelledby="agency-label"
                        aria-required="true"
                    ></b-agency>
                </div>
            </form>
        </section>

        <section
            ref="dashboardContent"
            class="dashboard-content"
            aria-labelledby="dashboard-content-heading"
            aria-live="polite"
            aria-atomic="false"            
        >
            <h2 id="dashboard-content-heading" class="visually-hidden">
                Agency dashboard updates
            </h2>
            <agency-notice :ori="agency"></agency-notice>
            <agency-submission :ori="agency"></agency-submission>
            <agency-overview :ori="agency"></agency-overview>
        </section>

     
           
            <system-alerts></system-alerts>
     
    </div>
</template>

<script lang="ts" setup>
import {ref, watch, nextTick} from "vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import {BAgency} from "./Fields";
import AgencyOverview from "./AgencyDashboard/AgencyOverview.vue";
import AgencyNotice from "./AgencyDashboard/AgencyNotice.vue";
import AgencySubmission from "./AgencyDashboard/AgencySubmission.vue";

const agency = ref();
const dashboardContent = ref<HTMLElement | null>(null);

watch(agency, async () => {
    await nextTick();
    dashboardContent.value?.focus();
});
</script>

<style>
.agency-dashboard {
    color: #212529;
    background-color: #ffffff;
}

</style>
